import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars

const { arrayOf, bool, number, objectOf, oneOfType, shape, string } = PropTypes; // eslint-disable-line no-unused-vars

export default shape({
  teamName: string,
  threadID: string,
  messageID: string,
  username: string,
  medium: string,
  mediumAddress: string,
  mediumMessageID: string,
  subject: string,
  timestamp: string,
  participants: arrayOf(string),
  shortBody: string,
  shortBodyTruncated: bool,
  notificationID: string,
  body: string
});



// WEBPACK FOOTER //
// ./js/types/api/message.js